export const validateOptionalURL = (args?: {
  url: URL | string | undefined
  domains?: Array<string>
}) => {
  const { url, domains } = args || {}

  if (!url) {
    return true
  }
  if (domains) {
    const hostNames = [
      domains.map((it) => `http://${it.toLocaleLowerCase()}/`),
      domains.map((it) => `https://${it.toLocaleLowerCase()}/`),
    ].flat()
    const matchDomain = hostNames.some(
      (it) => url.toString().toLowerCase().indexOf(it) === 0,
    )

    return URL.canParse(url) && matchDomain
  }

  return URL.canParse(url)
}
